import React from "react";

const SystemLinks = ({ folderUrl, coordinates }) => {
  return (
    <ul className='list-style-none'>
      {folderUrl !== null && folderUrl !== undefined ? (
        <li>
          <a href={folderUrl.value} target='_blank' rel='noreferrer'>
            eDocs
          </a>
        </li>
      ) : (
        <li>eDocs Link Not Available</li>
      )}
      {coordinates !== null && coordinates !== undefined ? (
        <li>
          {" "}
          <a
            href={`https://maps.google.com/?q=${coordinates.latitude},${coordinates.longitude}`}
            target='_blank'
            rel='noreferrer'
          >
            Google Map to source 'WS001'
          </a>
        </li>
      ) : (
        <li>Google Map to Source N/A</li>
      )}
    </ul>
  );
};

export default SystemLinks;
